import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import './Config.css'
import { log10 } from 'chart.js/helpers';
const Configurations = ({setCurrencyDash}) => {
    const [smallMedia, setSmallMedia] = useState(window.innerWidth <= 768);
    const [crntVrsn, setCrntVrsn] = useState("1.0.0");
    const [flDyCol, SetFlDyCol] = useState("");
    const [flTmCol, SetFlTmCol] = useState(new Date());
    const [flushId, setFlushId] = useState(null);
    const [isUpdate, setIsUpdate] = useState(false);
    const [isUpdateCur, setIsUpdateCur] = useState(false);
    const [currency, setCurrency] = useState("");
    useEffect(() => {
        getFlushData();
        getCurrency();
        const handleResize = () => {
            setSmallMedia(window.innerWidth <= 768);
        };
    
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
      }, []);

const createFlush = async () => {
  const userData = JSON.parse(sessionStorage.getItem('userData'));

  if (!userData || !userData.id) {
    alert('User ID not found');
    return;
  }

  const payload = {
    user_id: Number(userData.id),
    machine_id: Number(userData.selectedMachineIds),
    interval_days: Number(flDyCol),
    flush_time: flTmCol
  };

  try {
    const res = await axios.post(
      "/api/auto-flush",
      payload, // ✅ correct position
      {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}` // 🔥 IMPORTANT
        }
      }
    );

    alert("flush data Saved");
    setIsUpdate(true);
    setFlushId(res.data.id);

  } catch (err) {
    console.error(err.response?.data || err.message);
  }
};

const updateFlush = async (id) => {
  const userData = JSON.parse(sessionStorage.getItem('userData'));

  if (!userData || !userData.id) {
    alert('User ID not found');
    return;
  }

  const payload = {
    interval_days: Number(flDyCol),
    flush_time: flTmCol
  };


  try {
    await axios.put(
      `/api/auto-flush/${id}`,
      payload,
      {
        withCredentials: true
      }
    );

    alert("Flush data Updated");

  } catch (err) {
    console.error(err.response?.data || err.message);
  }
};


const saveFlshData = async () => {
  const userData = JSON.parse(sessionStorage.getItem("userData"));

  if (!userData || !userData.id) {
    alert("User not found");
    return;
  }

  const userId = userData.id;
  const macId = userData.selectedMachineIds;

  if (!flDyCol || !flTmCol) {
    alert("Please fill all fields");
    return;
  }

  const payload = {
    user_id: userId,
    machine_id: macId,
    interval_days: flDyCol,
    flush_time: flTmCol,
  };

  if (isUpdate) {
    // 🔥 UPDATE
    await updateFlush(flushId);
  } else {
    // 🔥 CREATE
    await createFlush();
  }
};



  const getFlushData = async () => {
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  if (!userData) return;

  const userId = userData.id;
  const macId = userData.selectedMachineIds;

  try {
    const res = await axios.get(
      `/api/auto-flush/${userId}/${macId}`,
      {
        withCredentials: true
      }
    );

    if (res.data.length > 0) {
      const data = res.data[0];
      // console.log(data, "auto flush");
      const timeDate = new Date();
      SetFlDyCol(data.interval_days);
      if (data.flush_time) {
  const [hours, minutes, seconds] = data.flush_time.split(":");

  timeDate.setHours(hours);
  timeDate.setMinutes(minutes);
  timeDate.setSeconds(seconds);

  SetFlTmCol(timeDate);
}
      setFlushId(data.id);

      setIsUpdate(true);
    } else {
      setIsUpdate(false);
    }

  } catch (err) {
    console.error(err.response?.data || err.message);
  }
};

const savecurncydta = async () => {
  const userData = JSON.parse(
    sessionStorage.getItem("userData")
  );
  if (currency === "") {
    alert("Please choose a currency");
    return;
  }
  if (!userData) return;
  const user_id = userData.id;
  const machine_id = userData.selectedMachineIds[0];

  try {
    const res = await axios.post(
      "/api/saveCurrency",
      {
        user_id,
        machine_id,
        type: currency,
      },
      {
        withCredentials: true,
      }
    );

    // console.log(res.data);
    alert(res.data.message)
    setCurrencyDash(currency);
    if(res.data.data.length > 0){
      setIsUpdateCur(true);
    }else{
      setIsUpdateCur(false);
    }
  } catch (err) {
    console.error(err);
  }
};

const getCurrency = async () => {
  const userData = JSON.parse(
    sessionStorage.getItem("userData")
  );
  if (!userData) return;

  const userId = userData.id;
  const machineId = userData.selectedMachineIds[0];

  try {
    const res = await axios.get(
      `/api/getCurrency/${userId}?machineId=${machineId}`,
      {
        withCredentials: true,
      }
    );

    if (res.data.data) {
      setCurrency(res.data.data.type);
      setCurrencyDash(res.data.data.type);
      setIsUpdateCur(true);
    }else{
      setIsUpdateCur(false)
    }
  } catch (err) {
    console.error(err);
  }
};
return (
    <div className="sp-recipes">
    <div className="recipe-left" style={{display: smallMedia ? "none" : "block"}} ></div>
    <div className='config-pg'>
    <div className='flsh-cont'>
    <div className='config-list flah-txt add-text nrml-txt'>Auto Flush</div>

    <div className='flh-dta-coll config-list'>
        
        <div className='dy-coll add-text nrml-txt'>
        <span>Flush After every </span> 
        <input 
            type='text' 
            value={flDyCol} 
            onChange={(e) => SetFlDyCol(e.target.value)} 
            placeholder='Day' 
        /> <span>days</span>
        </div>

<div className='tm-coll add-text nrml-txt'>
  <span>Time: </span>

  <DatePicker
    selected={flTmCol}
    onChange={(time) => SetFlTmCol(time)}
    showTimeSelect
    showTimeSelectOnly
    timeIntervals={15}
    timeCaption="Time"
    dateFormat="HH:mm"
    className='dte-pkr'
  />
</div>

        <div className="btnClose coll-sv-btn">
        <div className="new-close-cont-2 coll-actu-btn" onClick={saveFlshData}>
            <div className='shadeTriangle-recal-2'></div>

            <button className="close-btn coll-button">
            {isUpdate ? "Update" : "Save"}
            </button>

        </div>
        </div>

    </div>
    </div>

    <div className='curncy-list'>
    <div className='config-list flah-txt add-text nrml-txt'>Currency</div>
    <div className='crncy-div'>
    <div className='dy-coll add-text nrml-txt'>
        <span className='curr-span'>Currency: </span> 
        <select
          value={currency}
          onChange={(e) => setCurrency(e.target.value)}
          className="currency-select"
        >
        <option className='options' value="" >Choose Currency</option>
          <option className='options' value="$">$ - US Dollar</option>
          <option className='options' value="€">€ - Euro</option>
          <option className='options' value="£">£ - Pound</option>
        </select>
      </div>
      <div className="btnClose coll-sv-btn">
        <div className="new-close-cont-2 coll-actu-btn" onClick={savecurncydta}>
            <div className='shadeTriangle-recal-2'></div>

            <button className="close-btn coll-button">
            {isUpdateCur ? "Update" : "Save"}
            </button>

        </div>
        </div>
    </div>
    </div>


    <div className='config-list-vsn'>
    <div className="add-text nrml-txt">App version : {crntVrsn}</div>
    </div>
    </div>
    
    <div className="recipe-right" style={{display: smallMedia ? 'none' : 'block'}}></div>
    </div>
  );
};

export default Configurations;
